var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"member-control-member-profile-tab"}},[(_vm.company)?_c('MemberProfileSettings',{attrs:{"company":_vm.company}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }